import React from 'react';

/**
 * 5-star rating, read-only by default. Pass `onChange(n)` to make it
 * interactive (used in the review submission form).
 */
export default function Stars({ value, onChange, size = 18 }) {
  const v = Number(value || 0);
  return (
    <div style={{ display: 'inline-flex', gap: 2 }}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= v;
        const half = !filled && n - 0.5 <= v;
        const color = filled || half ? '#f59e0b' : '#cbd5e1';
        const star = (
          <span style={{ color, fontSize: size, lineHeight: 1 }}>{half ? '★' : (filled ? '★' : '☆')}</span>
        );
        return onChange ? (
          <button
            key={n} type='button'
            onClick={() => onChange(n)}
            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
          >
            {star}
          </button>
        ) : <span key={n}>{star}</span>;
      })}
    </div>
  );
}
